import React from 'react';

import { IconWrapper } from '@/components/ui/IconWrapper';
import {
  Anchor,
  BarChart3,
  Building2,
  Calculator,
  CircleHelp,
  Clock,
  DollarSign,
  Droplets,
  FileText,
  Flame,
  Fuel,
  Globe,
  Home,
  Landmark,
  Leaf,
  Map,
  MapPin,
  Pencil,
  Receipt,
  Search,
  Settings,
  ShieldCheck,
  Ship,
  ShoppingCart,
  Star,
  Users,
  Wrench,
  Zap
} from 'lucide-react';

type IconMapType = Record<string, React.ComponentType>;

const iconMap: IconMapType = {
  home: Home,
  tool: Wrench,
  settings: Settings,
  fire: Flame,
  apartment: Building2,
  bank: Landmark,
  chart: BarChart3,
  calculator: Calculator,
  clock: Clock,
  dollar: DollarSign,
  edit: Pencil,
  global: Globe,
  safety: ShieldCheck,
  shopping: ShoppingCart,
  star: Star,
  team: Users,
  thunder: Zap,

  // Legacy PNG icon mappings
  'gear-white': Settings,
  'edit-data-white': Pencil,
  'users-white': Users,
  'gas-white': Flame,
  fuel: Fuel,
  'calculator-white': Calculator,
  'invoice-white': FileText,
  'leaf-white': Leaf,
  'anchor-white': Anchor,
  'lubs-white': Droplets,
  'dollar-white': DollarSign,
  'map-marker-white': MapPin,
  'map-white': Map,
  'drill-white': Ship,
  'search-white': Search,
  'port-expense-white': Receipt,
  'certificate-white': ShieldCheck,
  'performance-white': BarChart3
};

export const getIcon = (iconName?: string): React.ReactNode => {
  if (!iconName) return <IconWrapper icon={CircleHelp} />;

  const key = iconName.toLowerCase().replace(/\.png$/, '');
  const IconComponent = iconMap[key] ?? CircleHelp;
  return <IconWrapper icon={IconComponent} />;
};
